"use strict";
'use client';
exports.__esModule = true;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var div_1 = tslib_1.__importDefault(require("../div"));
var class_names_1 = tslib_1.__importDefault(require("../utils/helpers/class-names"));
var RadioGroup = (0, react_1.forwardRef)(function RadioGroup(props, ref) {
    var children = props.children, className = props.className, onChange = props.onChange, value = props.value, rest = tslib_1.__rest(props, ["children", "className", "onChange", "value"]);
    var handleChange = function (e) {
        if (e.target.value && onChange) {
            onChange(e);
        }
    };
    return (react_1["default"].createElement(div_1["default"], tslib_1.__assign({ onClick: handleChange, "data-value": value, className: (0, class_names_1["default"])('md:flex-col', className), ref: ref }, rest), children));
});
exports["default"] = RadioGroup;
//# sourceMappingURL=radio-group.js.map